import { render, staticRenderFns } from "./store-addresses.vue?vue&type=template&id=f298ff42&"
import script from "./store-addresses.vue?vue&type=script&lang=js&"
export * from "./store-addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports